import { Title1 } from '@fluentui/react-components';
import React from 'react';

function Sitemap() {
    return (
        <>
            <h2>Sitemap</h2>

            <Title1>工事中</Title1>
        </>
    );
}
export default Sitemap;